import { useCarouselContext } from '../../context';

export function lensImpactProfileFontSizes(_fullWidth: number) {
  const defaultSize = 11;
  const sizes = {
    columnTitles: defaultSize,
    impactTitles: defaultSize,
    dimensionTitles: defaultSize,
    dimensionNetScores: defaultSize,
    impactNetScores: defaultSize,
    impactScores: defaultSize,
    netScore: 34,
    scoreTypeText: defaultSize,
    valueSetText: defaultSize,
    modelVersionText: defaultSize,
    actionText: defaultSize,
    inputsText: defaultSize,
    legendText: defaultSize,
  };
  return sizes;
}

export function useLensImpactProfileFontSizes() {
  const context = useCarouselContext();
  return lensImpactProfileFontSizes(context.width);
}
